import React from 'react'
import HeroSection from '../sections/HeroLandingSection/HeroSection'
import HeroCopySection from '../sections/HeroLandingSection/HeroCopySection'
import BottomSection from '../sections/BottomSection/BottomSection'
import Footer from '../sections/Footer/Footer'
import SearchStatsSection from '../sections/SearchStatsSection/SearchStatsSection'
import EmpireStateSection from '../sections/EmpireStateSection/EmpireStateSection'
import PlannedTrips from '../sections/PlannedTripsSection/PlannedTrips'
import StickyHighlightsSection from '../sections/StickyHighlightSection/StickyHighlightsSection'
import FinlandSection from '../sections/FinlandSection/FinlandSection'
import GallerySection from '../sections/GallerySection/GallerySection'
import TiktokSection from '../sections/TiktokSection/TiktokSection'
// import ReviewSection from '../sections/ReviewsSection/ReviewSection'
import FloatingPeople from '../sections/FloatingPeopleSection/FloatingPeople'
import MapSection from '../sections/MapSection/MapSection'
import ForumSection from '../sections/ForumSection/ForumSection'
import AdventuresSection from '../sections/AdventuresSection/AdventuresSection'
// import ReactGA from 'react-ga4';
import { inject } from '@vercel/analytics';

inject();


const Home = () => {

  return (
    <>
        <HeroSection />
        <HeroCopySection />
        <SearchStatsSection />
        <StickyHighlightsSection />
        <EmpireStateSection />
        <PlannedTrips />
        <AdventuresSection />
        <FinlandSection />
        <GallerySection />
        <TiktokSection  />
        <ForumSection />
        {/* <ReviewSection /> */}
        <FloatingPeople />
        <MapSection />
        <BottomSection />
        <Footer />

    </>
  )
}

export default Home